(function () {
  function getSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.dataset.sectionId; })
      .join(',');
  }

  function updateCart(sections) {
    if (window.Shopify && typeof window.Shopify.updateCartSections === 'function') {
      window.Shopify.updateCartSections(sections || {});
    }
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'cross-sell-tote', sections: sections || {} } },
      })
    );
  }

  function addToCart(variantId, callback) {
    var sectionIds = getSectionIds();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds) body.sections = sectionIds;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        updateCart(response.sections);
        if (callback) callback(null, response);
      })
      .catch(function (err) {
        if (callback) callback(err);
      });
  }

  // ── Cart drawer cross-sell: "Add for £14" ─────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-tote-add]');
    if (!btn) return;

    var widget = btn.closest('[data-cart-tote-cross-sell]');
    if (!widget) return;

    var variantId = parseInt(widget.dataset.toteVariantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    addToCart(variantId, function (err) {
      if (err) {
        btn.disabled = false;
        btn.textContent = '+ Add for £14';
      }
    });
  });

  // ── Pre-checkout popup ─────────────────────────────────────────────────────

  function proceedToCheckout() {
    window.location.href = '/checkout';
  }

  function openPopup(popup) {
    // Move to body before showModal() — the cart drawer is already in the top
    // layer, so a nested dialog can't enter it again. At body level, showModal()
    // places the popup above the drawer cleanly.
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
    try {
      popup.showModal();
    } catch (e) {
      popup.removeAttribute('hidden');
    }
  }

  function closePopup(popup) {
    try {
      popup.close();
    } catch (e) {
      popup.setAttribute('hidden', '');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#checkout[type="submit"]');
    if (!btn) return;

    var popup = document.getElementById('cart-checkout-popup');
    if (!popup) return;

    e.preventDefault();
    openPopup(popup);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-checkout-add]')) return;

    var popup = document.getElementById('cart-checkout-popup');
    var variantId = popup ? parseInt(popup.dataset.toteVariantId, 10) : 0;

    var btn = e.target.closest('[data-cart-checkout-add]');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    if (!variantId) {
      if (popup) closePopup(popup);
      proceedToCheckout();
      return;
    }

    var sectionIds = getSectionIds();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds) body.sections = sectionIds;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function () {
        if (popup) closePopup(popup);
        proceedToCheckout();
      })
      .catch(function () {
        if (popup) closePopup(popup);
        proceedToCheckout();
      });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-checkout-decline]')) return;
    var popup = document.getElementById('cart-checkout-popup');
    if (popup) closePopup(popup);
    proceedToCheckout();
  });

  // Backdrop click: dialog fires click on itself when ::backdrop is clicked
  document.addEventListener('click', function (e) {
    var popup = document.getElementById('cart-checkout-popup');
    if (!popup || !popup.open) return;
    if (e.target === popup) closePopup(popup);
  });

  // ── Tote page: "Add both to bag" ──────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tote-better-together-add]');
    if (!btn) return;

    var widget = btn.closest('[data-tote-better-together]');
    if (!widget) return;

    var puddingId = parseInt(widget.dataset.puddingVariantId, 10);
    var toteId    = parseInt(widget.dataset.toteVariantId, 10);
    if (!toteId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = [{ id: toteId, quantity: 1 }];
        var puddingInCart = (cart.items || []).some(function (item) {
          return String(item.variant_id) === String(puddingId);
        });
        if (puddingId && !puddingInCart) {
          items.push({ id: puddingId, quantity: 1 });
        }

        var sectionIds = getSectionIds();
        var body = { items: items };
        if (sectionIds) body.sections = sectionIds;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (res) { return res.json(); });
      })
      .then(function (response) {
        updateCart(response.sections);

        var drawerEl = document.querySelector('cart-drawer-component');
        if (drawerEl && typeof drawerEl.open === 'function') {
          drawerEl.open();
        }

        btn.disabled = false;
        btn.textContent = '+ Add both to bag';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Add both to bag';
      });
  });
})();
